import { css } from 'lit';
import { iconStyles } from '@healthgeek/ui';

export { iconStyles };

export const pageStyles = css`
  :host {
    display: block;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  .wrap {
    max-width: var(--hg-prose);
    margin: 0 auto;
    padding: 0 var(--hg-gutter);
  }
  .wrap-wide {
    max-width: var(--hg-max);
    margin: 0 auto;
    padding: 0 var(--hg-gutter);
  }
  .page {
    padding: 0 0 0;
  }
  .kicker {
    font-size: 12px;
    letter-spacing: 1.5px;
    color: var(--hg-muted);
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .kicker::before {
    content: '§ ';
    color: var(--hg-forest);
  }
  h1,
  h1.display {
    font-size: 28px;
    font-weight: 700;
    max-width: none;
    margin: 0 0 14px;
    letter-spacing: 0.2px;
  }
  .lede {
    font-size: 16px;
    color: var(--hg-charcoal);
    max-width: 66ch;
  }
  .hero {
    padding: 50px 0 34px;
    border-bottom: 1px solid var(--hg-line);
  }
  .hero-grid {
    display: grid;
    gap: 48px;
    align-items: center;
  }
  @media (min-width: 860px) {
    .hero-grid {
      grid-template-columns: 1.1fr 0.9fr;
    }
  }
  blockquote.lead {
    margin: 0 0 30px;
    padding: 0 0 0 22px;
    border-left: 3px solid var(--hg-forest);
  }
  blockquote.lead p {
    font-size: 21px;
    font-style: italic;
    line-height: 1.55;
    margin: 0 0 14px;
    color: var(--hg-ink);
  }
  blockquote.lead .attr {
    font-size: 13px;
    color: var(--hg-muted);
  }
  blockquote.pull {
    margin: 26px 0;
    padding: 0 0 0 22px;
    border-left: 3px solid var(--hg-forest);
  }
  blockquote.pull p {
    font-style: italic;
    font-size: 17px;
    margin: 0;
    color: var(--hg-ink);
  }
  .hero-actions,
  .actions {
    display: flex;
    gap: 14px;
    margin-top: 30px;
    flex-wrap: wrap;
  }
  .section {
    padding: 50px 0;
    border-bottom: 1px solid var(--hg-line);
  }
  .section.no-border {
    border-bottom: none;
  }
  .section-num {
    font-size: 12px;
    color: var(--hg-muted);
    letter-spacing: 1px;
    margin-bottom: 14px;
  }
  h2 {
    font-size: 21px;
    font-weight: 700;
    margin: 0 0 16px;
  }
  p {
    font-size: 15.5px;
    color: var(--hg-charcoal);
    margin: 0 0 16px;
    max-width: 68ch;
  }
  p.first {
    font-size: 16.5px;
    color: var(--hg-ink);
  }
  .muted {
    color: var(--hg-muted);
  }
  .illus-card {
    background: #fff;
    border: 1px solid var(--hg-line);
    border-radius: 16px;
    box-shadow: var(--md-sys-elevation-1);
    overflow: hidden;
  }
  .illus-card svg,
  .illus-card img {
    display: block;
    width: 100%;
    height: auto;
  }
  .illus-card img.hero-illus-img {
    aspect-ratio: 1 / 1;
    object-fit: cover;
    image-rendering: -webkit-optimize-contrast;
  }
  .illus-caption {
    padding: 14px 18px;
    font-size: 12px;
    color: var(--hg-muted);
    letter-spacing: 0.3px;
    border-top: 1px solid var(--hg-line);
  }
  .counters-grid,
  .grid-4 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .grid-2,
  .grid-3 {
    display: grid;
    gap: 16px;
  }
  @media (min-width: 720px) {
    .counters-grid,
    .grid-4 {
      grid-template-columns: 1fr 1fr;
    }
    .grid-2 {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (min-width: 900px) {
    .counters-grid,
    .grid-4 {
      grid-template-columns: repeat(4, 1fr);
    }
    .grid-3 {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .counter-card {
    background: #fff;
    border: 1px solid var(--hg-line);
    border-radius: 14px;
    padding: 18px;
    box-shadow: var(--md-sys-elevation-1);
  }
  .chip {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    flex-shrink: 0;
  }
  .chip.forest {
    background: var(--hg-forest-tint);
  }
  .chip.coral {
    background: var(--hg-coral-tint);
  }
  .chip.sky {
    background: var(--hg-sky-tint);
  }
  .chip.amber {
    background: var(--hg-amber-tint);
  }
  .counter-card .num {
    font-weight: 700;
    font-size: 22px;
  }
  .counter-card .label {
    font-size: 12.5px;
    color: var(--hg-muted);
    margin-top: 4px;
  }
  .counters-note {
    text-align: center;
    font-size: 12px;
    color: var(--hg-muted);
    margin-top: 22px;
  }
  ol.ways {
    list-style: none;
    margin: 0;
    padding: 0;
    counter-reset: way;
  }
  ol.ways li {
    counter-increment: way;
    padding: 20px 0;
    border-top: 1px solid var(--hg-line);
    display: flex;
    gap: 18px;
    align-items: flex-start;
  }
  ol.ways li:not(:has(.chip))::before {
    content: '[' counter(way, decimal-leading-zero) ']';
    font-weight: 700;
    color: var(--hg-forest);
    flex-shrink: 0;
  }
  ol.ways li:first-child {
    border-top: none;
  }
  ol.ways .chip {
    margin-bottom: 0;
  }
  ol.ways h3 {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 6px;
  }
  ol.ways p {
    margin: 0;
    font-size: 14px;
  }
  .program-teaser {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }
  @media (min-width: 860px) {
    .program-teaser {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .teaser-card {
    background: #fff;
    border: 1px solid var(--hg-line);
    border-radius: 14px;
    overflow: hidden;
    box-shadow: var(--md-sys-elevation-1);
    display: block;
    text-decoration: none;
    color: inherit;
  }
  .teaser-card svg {
    width: 100%;
    height: 120px;
    display: block;
    background: var(--hg-paper-2);
  }
  .teaser-body {
    padding: 18px;
  }
  .teaser-tag {
    font-size: 10.5px;
    letter-spacing: 1px;
    color: var(--hg-forest);
    text-transform: uppercase;
    margin-bottom: 8px;
  }
  .teaser-body h3 {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 8px;
  }
  .teaser-body p {
    font-size: 13px;
    margin: 0;
  }
  .closing {
    background: var(--hg-paper-2);
    text-align: center;
    padding: 60px 0;
    border-bottom: none;
  }
  .closing p.lead {
    font-size: 19px;
    font-style: italic;
    max-width: 34ch;
    margin: 0 auto 30px;
    color: var(--hg-ink);
  }
  .closing-actions {
    display: flex;
    justify-content: center;
    gap: 14px;
    flex-wrap: wrap;
  }
  .program-entry,
  #donate,
  #mali,
  #juvo,
  #dental-intelligence {
    scroll-margin-top: 12px;
  }
  .program-entry {
    padding: 44px 0;
    border-bottom: 1px solid var(--hg-line);
  }
  .program-entry:last-of-type {
    border-bottom: none;
  }
  .entry-grid {
    display: grid;
    gap: 40px;
    align-items: start;
  }
  @media (min-width: 860px) {
    .entry-grid {
      grid-template-columns: 1fr 260px;
    }
  }
  .program-entry h2 {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 14px;
  }
  .program-tag {
    font-size: 11.5px;
    letter-spacing: 1px;
    color: var(--hg-forest);
    text-transform: uppercase;
    margin-bottom: 12px;
  }
  .who {
    font-size: 13px;
    color: var(--hg-muted);
    border-left: 2px solid var(--hg-line);
    padding-left: 12px;
    margin: 18px 0;
  }
  .p-link {
    font-size: 13.5px;
    font-weight: 700;
    border-bottom: 1px solid var(--hg-ink);
    text-decoration: none;
  }
  .meta-row {
    display: flex;
    gap: 26px;
    font-size: 13px;
    color: var(--hg-muted);
    margin: 18px 0;
    flex-wrap: wrap;
  }
  .meta-row div span {
    display: block;
    color: var(--hg-ink);
    font-weight: 700;
    font-size: 15px;
  }
  .value-entry,
  .committee,
  .contact-block {
    padding: 22px 0;
    border-top: 1px solid var(--hg-line);
  }
  .value-entry:first-of-type,
  .committee:first-of-type,
  .contact-block:first-of-type {
    border-top: none;
  }
  .value-entry .n,
  .contact-block .n {
    font-size: 12px;
    color: var(--hg-forest);
    letter-spacing: 1px;
    margin-bottom: 8px;
  }
  .value-entry h3,
  .committee h3 {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 8px;
  }
  .value-entry p,
  .committee p {
    font-size: 14.5px;
    margin: 0;
  }
  table.roster {
    width: 100%;
    border-collapse: collapse;
    font-size: 14.5px;
    margin-top: 10px;
  }
  table.roster td {
    padding: 14px 6px;
    border-top: 1px solid var(--hg-line);
  }
  table.roster tr:first-child td {
    border-top: none;
  }
  table.roster td.role {
    color: var(--hg-muted);
    text-align: right;
    font-size: 13.5px;
  }
  .amounts {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 20px;
  }
  .amounts button {
    min-height: 2.5rem;
    border: 1px solid var(--hg-line);
    background: var(--hg-paper);
    font: inherit;
    font-weight: 700;
    cursor: pointer;
  }
  .amounts button:hover {
    border-color: var(--hg-forest);
    color: var(--hg-forest);
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  @media (min-width: 720px) {
    .form-row {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (max-width: 520px) {
    .amounts {
      grid-template-columns: 1fr 1fr;
    }
  }
  label {
    display: block;
    font-size: 12.5px;
    color: var(--hg-muted);
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
  input,
  textarea,
  select {
    width: 100%;
    background: var(--hg-paper);
    border: 1px solid var(--hg-line);
    padding: 11px 12px;
    font-family: inherit;
    font-size: 14.5px;
    color: var(--hg-ink);
    border-radius: 0;
  }
  input:focus,
  textarea:focus,
  select:focus {
    outline: none;
    border-color: var(--hg-forest);
  }
  textarea {
    resize: vertical;
    min-height: 110px;
  }
  .prose h2 {
    font-size: 21px;
    margin: 0 0 16px;
  }
  .prose p {
    margin: 0 0 16px;
    max-width: 66ch;
  }
  .prose ul {
    margin: 0 0 16px;
    padding-left: 1.15rem;
    color: var(--hg-charcoal);
  }
  @media (max-width: 760px) {
    table.roster td.role {
      text-align: left;
      display: block;
    }
  }
`;
